import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/**
 * ConfirmPasswordComponent.
 * Handles the display and logic for the password confirmation page.
 */
@Component({
  selector: 'app-confirm-password',
  standalone: true,
  imports: [],
  templateUrl: './confirm-password.component.html',
  styleUrl: './confirm-password.component.scss'
})
export class ConfirmPasswordComponent {

  constructor(private route: ActivatedRoute) {}
  
/**
 * Lifecycle hook that is called after data-bound properties are initialized.
 * Checks for the "anything" parameter in the route and redirects if present.
 */
ngOnInit(): void {

    // Redirect to external URL if "anything" exists
    window.location.href = 'https://mamorun99.com';
  
}
}
